'use client'

import { useCallback } from 'react'
import {
  shouldApplyMarketingParams,
  withMarketingParams,
} from 'lib/marketingParams'
import usePartnershipCodeUrl from 'hooks/usePartnershipCodeUrl'

export { shouldApplyMarketingParams }

/**
 * Returns a function that appends partnership code and persisted marketing
 * params to on-site / thriveworks.com footer links.
 */
export function useFooterLinkUrl(): (url: string) => string {
  const addPartnershipCodeToUrl = usePartnershipCodeUrl()

  return useCallback(
    (url: string) => {
      if (!shouldApplyMarketingParams(url)) {
        return url
      }

      return withMarketingParams(addPartnershipCodeToUrl(url))
    },
    [addPartnershipCodeToUrl]
  )
}

export default useFooterLinkUrl
